export default __webpack_public_path__ + "9da3bbeb8287f7d7bad75797d5d38b04.png";